<template>
  <div class="ui modal" ref="modal">
    <i class="close icon"></i>
    <div class="icon header">
      <i class="envelope outline icon"></i>
      {{ $t("message") }}
    </div>
    <div class="image content">
      <div class="ui small image">
        <img src="/images/icons/outbox.png" style="width: 100% !important" />
      </div>
      <div class="description" style="width: 100% !important">
        <div class="ui form">
          <div class="three fields">
            <div class="field">
              <label for="">{{ $t("message name") }}</label>
              <input type="text" name="name" v-model="setup.name" />
            </div>
            <div class="field">
              <label for="">{{ $t("addressee") }}</label>
              <input type="text" name="addressee" v-model="setup.addressee" />
            </div>
            <div class="field">
              <label for="">{{ $t("send date") }}</label>
              <div class="ui calendar" ref="send_date">
                <div class="ui input left icon">
                  <i class="calendar icon"></i>
                  <input type="text" :placeholder="$t('send date')" />
                </div>
              </div>
              <!-- <div class="ui selection dropdown" ref="provider_dropdown">
                <input type="hidden" name="provider" />
                <i class="dropdown icon"></i>
                <div class="default text"></div>
                <div class="menu"></div>
              </div> -->
            </div>
          </div>
          <h4 class="ui dividing header">{{ $t("arguments") }}</h4>
          <div
            class="field"
            v-for="(argument, i) in setup.message_args"
            :key="i"
          >
            <label for="">{{ argument.name }}</label>
            <input type="text" v-model="setup.message_args[i].default_value" />
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="ui blue icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
      <div class="ui green icon right labeled button" @click="save">
        <i class="save icon"></i>
        {{ $t("save") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
// import moment from "moment";

export default {
  name: "ProviderModalIndex",
  components: {},
  props: {},
  computed: {},
  data() {
    return {
      uuid: "",
      setup: {
        name: "",
        addressee: "",
        send_date: "",
        provider_id: "",
        message_args: [],
      },
    };
  },
  methods: {
    show_modal(options) {
      if (!options) options = {};
      let vm = this;

      /**
       * get template
       */
      if (options.message_uuid) {
        local_api(vm, "post", "/outbox/message/do-get", {
          u: options.message_uuid,
        })
          .then((msg) => {
            let args = msg.setup.message_args;
            vm.setup.message_args = args;
            vm.setup.template_id = msg.out_template.template_id;

            vm.setup.name = msg.name;
            vm.setup.addressee = msg.setup.addressee;
            if (msg.programmed_send_date) {
              vm.setup.send_date = msg.programmed_send_date;
              window
                .jQuery(vm.$refs.send_date)
                .calendar("set date", msg.programmed_send_date);
            }
            vm.uuid = msg.uuid;
            // vm.provider_id: "",
          })
          .catch((err) => {
            error_toast(err);
          });
      } else if (options.template_uuid) {
        local_api(vm, "post", "/outbox/template/do-get", {
          u: options.template_uuid,
        })
          .then((tpl) => {
            let args = tpl.setup.arguments;
            vm.setup.message_args = args;
            vm.setup.template_id = tpl.template_id;
          })
          .catch((err) => {
            error_toast(err);
          });
      }

      var today = new Date();
      window
        .jQuery(vm.$refs.modal)
        .modal({
          allowMultiple: true,
          onVisible() {
            window.jQuery(vm.$refs.send_date).calendar({
              today: true,
              minDate: new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate(),
                today.getHours(),
                today.getMinutes(),
              ),
              onChange(value) {
                vm.setup.send_date = value;
              },
            });
          },
          onHide() {
            // vm.uuid = "";
            // vm.setup = {
            //   name: "",
            //   library: "",
            //   setup: {},
            // };
          },
        })
        .modal("show");
    },
    save() {
      let vm = this;

      local_api(vm, "post", "/outbox/message/do-save", {
        s: vm.setup,
        i: vm.uuid,
      })
        .then(() => {
          window.jQuery(vm.$refs.modal).modal("hide");
          vm.$emit("success");
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  mounted() {
    // window.jQuery(this.$refs.form).form({
    //   fields: {
    //     name: ["empty"],
    //   },
    // });
  },
  watch: {},
  updated: function () {},
};
</script>
